var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 14.2023,
    transform: "rotate(-39.7242 20 20)",
    fill: "#8375E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 25.6,
    rx: 3.2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 32.0902 5.3255)",
    fill: "#F09FED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 25.6,
    rx: 3.2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 29.8274 21.1646)",
    fill: "#F09FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a41896879ace16ce6406ea1f20e1e949.svg";
export { ForwardRef as ReactComponent };